export default __webpack_public_path__ + "static/media/b-14.ac516de5.png";